import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BuilderRequest } from 'src/app/models/requests';
import { PersonDialogComponent } from '../../../person-dialog/person-dialog.component';

@Component({
  selector: 'app-personlistitem',
  templateUrl: './personlistitem.component.html'
})
export class PersonListItemComponent implements OnInit {

  @Input('person') person: any;
  @Input('index') index: any;
  @Input('request') request!: BuilderRequest;
  @Input('dossierPersonsAmount') dossierPersonsAmount: number = 0;
  @Input('sortingAllowed') sortingAllowed: boolean = true;
  @Output('PersonUpdated') personUpdated = new EventEmitter();
  @Output('PersonRemoved') personRemoved = new EventEmitter();
  @Output('PersonChangeOrder') personChangeOrder = new EventEmitter();
  @Input('showMessage') showMessage!: boolean;
  @Output('EnablePersonChangeOrder') enablePersonChangeOrder = new EventEmitter();

  fullname: string = '';
  showgrip: boolean = false;

  constructor(private modalService: NgbModal) {
    //May not been empty
  }

  ngOnInit(): void { 
    this.fullname = this.person.fullName ?? this.person.firstname + " " + this.person.prefix + " " + this.person.lastname;
    this.fullname = this.fullname.replaceAll("  ", " ");
  }

  PersonRemoved() {
    this.personRemoved.emit(this.person)
  }

  EditPerson(event: Event) {
    let ngbModalOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
      backdrop : 'static'
    };
    const modalRef = this.modalService.open(PersonDialogComponent, ngbModalOptions);
    modalRef.componentInstance.personToEdit = this.person;
    modalRef.componentInstance.showMessage = this.showMessage;
    modalRef.closed.subscribe(
      (value: any) => {
        if (!value) return;

        this.personUpdated.emit(value.person);
      }
    );
  }

  EnablePersonChangeOrder(position: number, id: string) {
    this.showgrip = true;
    this.enablePersonChangeOrder.emit({position: position, id: id});
  }

  personHasIdentityProvider() {
    return this.person.identityProvider !== '' && this.person.identityProvider !== null;
  }

  personHasNoIdentityProvider() {
    return !this.personHasIdentityProvider();
  }
}
